export default __webpack_public_path__ + "static/media/FELES_Facturador_white.5dac8572.svg";